import { ref, computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import i18n from '@/libs/i18n'

export default function useAppCustomizer() {
  // Customizer
  const isCustomizerOpen = ref(false)

  // Skin
  const skinOptions = computed(() => [
    { text: i18n.t('Light'), value: 'light' },
    { text: i18n.t('Bordered'), value: 'bordered' },
    { text: i18n.t('Dark'), value: 'dark' },
    { text: i18n.t('Semi Dark'), value: 'semi-dark' },
  ])

  // Content Width Options
  const contentWidthOptions = computed(() => [
    { text: i18n.t('Full Width'), value: 'full' },
    { text: i18n.t('Boxed'), value: 'boxed' },
  ])

  // Router Transition
  const routerTransitionOptions = computed(() => [
    { title: i18n.t('Zoom Fade'), value: 'zoom-fade' },
    { title: i18n.t('Fade'), value: 'fade' },
    { title: i18n.t('Fade Bottom'), value: 'fade-bottom' },
    { title: i18n.t('Slide Fade'), value: 'slide-fade' },
    { title: i18n.t('Zoom Out'), value: 'zoom-out' },
    { title: i18n.t('None'), value: 'none' },
  ])

  // Router Transition
  const layoutTypeOptions = [
    { text: 'Vertical', value: 'vertical' },
    { text: 'Horizontal', value: 'horizontal' },
  ]

  // Navbar
  const navbarColors = ['', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']

  // Navbar Types
  const navbarTypes = [
    { text: 'Floating', value: 'floating' },
    { text: 'Sticky', value: 'sticky' },
    { text: 'Static', value: 'static' },
    { text: 'Hidden', value: 'hidden' },
  ]

  // Footer Types
  const footerTypes = [
    { text: 'Sticky', value: 'sticky' },
    { text: 'Static', value: 'static' },
    { text: 'Hidden', value: 'hidden' },
  ]

  // eslint-disable-next-line object-curly-newline
  const {
    isRTL,
    skin,
    contentWidth,
    routerTransition,
    layoutType,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    navbarBackgroundColor,
    navbarType,
    footerType,
  } = useAppConfig()

  return {
    // Customizer
    isCustomizerOpen,

    // Vertical Menu
    isVerticalMenuCollapsed,

    // Skin
    skin,
    skinOptions,

    // Content Width
    contentWidth,
    contentWidthOptions,

    // RTL
    isRTL,

    // routerTransition
    routerTransition,
    routerTransitionOptions,

    // Layout Type
    layoutType,
    layoutTypeOptions,

    // NavMenu Hidden
    isNavMenuHidden,

    // Navbar
    navbarColors,
    navbarTypes,
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerTypes,
    footerType,
  }
}
